import React from "react";
import {Box, Button, Flex, Text} from "rebass";

interface IProps {
  handleOnClick(): void;
}

export function SuccessMessage({ handleOnClick }: IProps) {
  return (
    <Flex
      height="100%"
      justifyContent="center"
      alignItems="center"
    >
      <Box>
        <Text
          as="p"
          fontSize="30px"
          fontWeight="bold"
          lineHeight={1.07}
          color="#2b3160"
        >
          <span>Thank you for reaching out</span>

          &nbsp;

          <span
            role="img"
            aria-label="star-struck"
          >
            &#x1F929;
          </span>
        </Text>

        <Text
          mt="10px"
          mb="24px"
          fontSize="14px"
          lineHeight={1.57}
          color="wild-blue"
        >
          We will answer shortly.
        </Text>

        <Button
          type="button"
          px="35px"
          py="17px"
          color="#fff"
          bg="sp-blue"
          borderRadius="5px"
          onClick={handleOnClick}
        >
          <Text
            fontSize="14px"
            css="text-transform: uppercase;"
          >
            write another feedback
          </Text>
        </Button>
      </Box>
    </Flex>
  )
}
